import {
  SimilarDesignItem,
  SimilarDesigns,
} from '@app/data/clients/rbServerSideClient/queries/GetSimilarDesigns/types';
import { defineMessages, type IntlShape } from '@redbubble/next/intl';
import { CarouselMediaCardProps } from 'components/CarouselSection/types';
import { PriceProps } from 'components/Price/Price';
import {
  ListsButtonInventoryItem,
  ListsInclusions,
} from '../../../../types/shop-bff/types';
import { getPreviewUrl } from '../../../../utils/common';
import { PreviewStyle } from '../../constants';

const messages = defineMessages({
  byArtist: {
    defaultMessage: 'By {artistName}',
  },
});

export const mapMediaCardProps = (
  listsInclusions: ListsInclusions | null,
  groupId: string | null,
  seoLinkLimit?: number
) => {
  return (
    inputData: SimilarDesignItem,
    intl: IntlShape,
    index: number
  ): CarouselMediaCardProps | null => {
    if (!inputData || !inputData.inventoryItem) return null;
    const hiddenLink =
      seoLinkLimit === 0 ||
      (seoLinkLimit !== undefined && seoLinkLimit <= index);
    // TODO: When IHS schema updates, remove nullish option
    const artistName =
      inputData.inventoryItem.work.artistShopDisplayName ?? undefined;
    return {
      productId: inputData?.inventoryItemId,
      link: inputData.inventoryItem.productPageUrl || '',
      imageSrc: getPreviewUrl(
        inputData.inventoryItem,
        groupId
          ? PreviewStyle.ALTERNATE_PRODUCT_CLOSE
          : PreviewStyle.CLOSE_PREVIEW
      ),
      title: `${inputData.inventoryItem.work.title || ''} ${
        inputData.inventoryItem.description || ''
      }`,
      workTitle: inputData.inventoryItem.work.title || '',
      artistName,
      caption: intl.formatMessage(messages.byArtist, {
        artistName,
      }),
      loading: false,
      key: `sd-${inputData?.inventoryItemId}`,
      testId: `sd-media-card-${inputData?.inventoryItemId}`,
      matureContent: inputData.inventoryItem.work.matureContent,
      addToListButtonProps: {
        inventoryItem: inputData.inventoryItem as ListsButtonInventoryItem,
        workId: inputData.inventoryItem.work.id || '',
        listsInclusions,
      },
      hideLink: hiddenLink,
      stockStatus: inputData.inventoryItem.stockStatus,
    };
  };
};

export const mapPriceProps = (input: SimilarDesignItem): PriceProps | null => {
  if (!input.inventoryItem?.price) return null;

  const { discount, currency, amount } = input.inventoryItem.price;

  return {
    discount,
    currency,
    amount,
  };
};

export const getUsableSimilarDesigns = (similarDesigns: SimilarDesigns) => {
  return similarDesigns
    .map((recommendation: SimilarDesignItem) => {
      if (!recommendation.inventoryItem) return null;
      if (!recommendation.inventoryItem.productPageUrl) return null;

      return recommendation;
    })
    .filter(Boolean);
};
